/// <amd-module name="Agile/Directory/Components/DirectoryGrid/NameCell" />
import { IDirectoryRow } from "Agile/Directory/Components/DirectoryGrid/DirectoryGrid.Props";
import * as DirectoryResources from "Agile/Directory/Resources";
import { IDirectoryArtifact } from "DirectoryContracts";
import { InfoIcon } from "VSSUI/InfoIcon";
import { Link } from "VSSUI/Link";
import * as React from "react";
import { css } from "VSS/Platform/Layout";
import { Tooltip } from "VSSUI/TooltipEx";
import { IVssIconProps, VssIcon, VssIconType } from "VSSUI/VssIcon";
import { FavoritesStarButton } from "Favorites/Star/FavoritesStarButton";

export interface INameCellProps<T extends IDirectoryArtifact> {
    artifactIconProps?: IVssIconProps;
    row: IDirectoryRow<T>;
    onFavoriteToggled: (row: IDirectoryRow<T>) => void;
    onClick: (row: IDirectoryRow<T>, index: number | undefined, ev: Event) => void;
}

/**
 * The name cell renders the name portion of a row and handles the favoriting behavior
 */
export class NameCell<T extends IDirectoryArtifact> extends React.PureComponent<INameCellProps<T>> {
    public render(): JSX.Element {
        const {
            row: {
                data: { name, url },
                errorMessage,
                isDeleted,
                isFavorited,
                iconProps
            }
        } = this.props;

        return (
            <div className="directory-row-name-cell">
                {iconProps && <VssIcon {...iconProps} className="directory-artifact-icon" />}

                <Tooltip overflowOnly={true} text={name}>
                    <span className="directory-row-title flex-tooltip-host">
                        {isDeleted ? (
                            `${name} (${DirectoryResources.DeletedContent})`
                        ) : (
                            <Link className="directory-title" href={url} onClick={this._onClicked}>
                                {name}
                            </Link>
                        )}
                    </span>
                </Tooltip>
                <div className={css("directory-row-favorite", isFavorited && "favorited")}>
                    <FavoritesStarButton className="directory-row-favorite-icon" isFavorited={isFavorited} onToggleFavorite={this._onFavorite} />
                </div>
                <div className="directory-row-error">
                    {errorMessage && (
                        <InfoIcon
                            infoText={errorMessage}
                            iconProps={{
                                iconType: VssIconType.fabric,
                                iconName: "Error"
                            }}
                        />
                    )}
                    {errorMessage && (
                        <div className="directory-row-error-annoucement screenreader" aria-live="assertive">
                            {errorMessage}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    private _onFavorite = (event: React.MouseEvent<any>): void => {
        const { row, onFavoriteToggled } = this.props;

        event.stopPropagation();
        if (onFavoriteToggled) {
            onFavoriteToggled(row);
        }
    };

    private _onClicked = (event: React.MouseEvent<HTMLAnchorElement>): void => {
        const { row, onClick } = this.props;

        if (!event.ctrlKey && !event.metaKey && !event.shiftKey && onClick) {
            event.preventDefault();
            onClick(row, undefined, event.nativeEvent);
        }
    };
}
